import _ from 'lodash';

const bulletSvg = d3.create('svg');
bulletSvg.attr('viewBox', '7 7 17 13');
// bulletSvg.style('stroke', '#ff0000');
bulletSvg.append('path')
    .attr('d', 'M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z');

const svgBullets = {};
function svgBullet(colour) {
    if (!svgBullets[colour]) {
        svgBullets[colour] = bulletSvg.node().cloneNode(true);
    }
    return svgBullets[colour];
}


function bulletLink(link, colour) {
    return {
        mt: 'h-0-1/8',
        // border: { colour },
        bullet: {
            w: 'w-0-1/4',
            // h: 'h-0-1/4',
            // border: { colour },
            icon: {
                h: 11,
                w: 10,
                ml: 6,
                styles: { stroke: colour, fill: colour },
                svg: svgBullet(colour)
            }
        },
        link: {
            display: 'inline',
            w: 'w-1-3/4',
            // border: { colour: '#000000' },
            text: link
        }
    };
}

function bulletList(links, colour) {
    return {
        w: 'w-2',
        ..._.map(links, (link) => bulletLink(link, colour)),
    };
}

export function createList(
    { linkedTo, colour, title },
    options
) {
    const col1Links = _.take(linkedTo, Math.ceil(linkedTo.length / 2));
    const col2Links = _.takeRight(linkedTo, Math.floor(linkedTo.length / 2));
    return {
        background: { colour: 'neutral.5' },
        top: {
            background: { colour },
            h: 30,
            font: 'background',
            label: {
                x: 'w-0-1/4',
                text: `${title}:`,
                mt: 12,
                // mb: 7,
                font: { weight: 'bold' }
            }
        },
        linkedTo1: bulletList(col1Links, colour),
        linkedTo2: {
            display: 'inline',
            ...bulletList(col2Links, colour)
        },
        ...options
        // svg: bulletSvg.node()
    };
}

export default ({ linkedTo, negativeTitle, colorClass: colour }, options) => {
    if (linkedTo && linkedTo.length) {
        const title = `${negativeTitle} is linked to`;
        return createList({ linkedTo, colour, title }, options);
    }
    return null;
};
